import React from "react"
import SimpleTimeEditor from "../common/SimpleTimeEditor"
import strings from "../../localization/strings"
import FinddDatePicker from "../common/FinddDatePicker"
import { blueGrey500 } from "material-ui/styles/colors"
import moment from "moment"
import { IDate } from "../../models"
import HierarchyJobTimezoneStr from "../common/HierarchyJobTimezoneStr"

interface IProps {
    hierarchyId: string
    jobId: string
    date: IDate
    hour: number
    minute: number
    readonly?: boolean
    handleChange(date: IDate, hour: number, minute: number): void
}

const PunchDateTimeSelector: React.SFC<IProps> = (props: IProps) => {
    return (
        <div>
            <div style={{ display: "flex" }}>
                <i className="fa fa-clock-o" style={{ marginRight: 10, marginTop: 15 }} />
                <SimpleTimeEditor
                    readonly={props.readonly}
                    simpleTime={{ Hour: props.hour, Minute: props.minute }}
                    handleChange={simpleTime => props.handleChange(props.date, simpleTime.Hour, simpleTime.Minute)}
                />
                <span style={{ marginLeft: 20, marginTop: 15 }}>
                    {strings.Timezone}:&nbsp;
                    <HierarchyJobTimezoneStr
                        hierarchyId={props.hierarchyId}
                        jobId={props.jobId}
                        localTime={props.date}
                    />
                </span>
            </div>
            <div style={{ paddingTop: 10, display: "inline-block" }}>
                <i className="fa fa-calendar" style={{ marginRight: 10 }} />
                <FinddDatePicker
                    data-intercom-target={"Select-Date"}
                    style={{ display: "inline-block" }}
                    onChange={(e, date) => props.handleChange(moment(date).startOf("day"), props.hour, props.minute)}
                    hintText={strings.Select_a_date}
                    value={moment(props.date).toDate()}
                    cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                    firstDayOfWeek={0}
                    disabled={props.readonly}
                />
            </div>
        </div>
    )
}

export default PunchDateTimeSelector